"use client";

import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/state/globalStore";
import { listFeedbackLinks } from "../api/listFeedbackLinks";
import { feedbackKeys } from "./keys";

export default function useFeedbackLinksQuery() {
  const { accessToken } = useAuth();

  return useQuery({
    queryKey: feedbackKeys.links(),
    queryFn: () => listFeedbackLinks(accessToken),
    enabled: Boolean(accessToken),
    staleTime: 1000 * 60,
  });
}
